module.exports = __webpack_public_path__ + "8f58f317340a78546236a2b772b9a6bf.svg";